"use client";

import React, { useState } from "react";
import { useTireReading } from "@/app/context/TireReadingContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGrid5, faCheck } from "@fortawesome/pro-regular-svg-icons";
import TireCodeSelectorModal from "./TireCodeSelectorModal";
import TireAdjustmentModal from "./TireAdjustmentModal";

interface TireActionBlockProps {
  code: "OK" | "Anders";
}

const TireActionBlock: React.FC<TireActionBlockProps> = ({ code }) => {
  const { selected, confirmClassificationChange, initial } = useTireReading();

  const [showSelectorModal, setShowSelectorModal] = useState(false);
  const [showAdjustmentModal, setShowAdjustmentModal] = useState(false);
  const [selectedCode, setSelectedCode] = useState<string | null>(null);

  const isSelected = selected === code;
  const icon = code === "OK" ? faCheck : faGrid5;

  const handleCodeSelect = (selectedCode: string) => {
    setSelectedCode(selectedCode);
    if (selectedCode !== initial) {
      setShowAdjustmentModal(true);
    }
  };

  const handleClick = () => {
    if (code === "Anders") {
      setShowSelectorModal(true);
    } else {
      confirmClassificationChange(code);
    }
  };

  const handleAdjustmentConfirm = (
    reason: string,
    depth: number,
    width?: number,
    height?: number,
    rim?: number
  ) => {
    confirmClassificationChange(
      selectedCode,
      reason,
      depth,
      width,
      height,
      rim
    );
  };

  return (
    <>
      <div
        onClick={handleClick}
        className={`
          p-10 rounded-2xl shadow-md flex flex-col items-center justify-center cursor-pointer transition-all w-48 h-48
          ${
            isSelected
              ? "bg-[var(--granu-green)] text-white scale-102"
              : "bg-gray-200 hover:bg-gray-300"
          }
        `}
      >
        <FontAwesomeIcon icon={icon} className="text-5xl mb-2" />
        <span className="text-xl font-semibold">{code}</span>
      </div>

      {showSelectorModal && (
        <TireCodeSelectorModal
          onClose={() => setShowSelectorModal(false)}
          onSelect={(selectedCode) => {
            handleCodeSelect(selectedCode);
            setShowSelectorModal(false);
          }}
        />
      )}

      {showAdjustmentModal && (
        <TireAdjustmentModal
          initialDepth={2.0}
          onClose={() => setShowAdjustmentModal(false)}
          onConfirm={handleAdjustmentConfirm}
        />
      )}
    </>
  );
};

export default TireActionBlock;
